import React from 'react';
import './MediaType.scss';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faVideo, faClipboardList, faComputerMouse } from '@fortawesome/free-solid-svg-icons';

const MediaType = ({ type }) => {
	const typeLowerCase = type.toLowerCase();

	const setVideo = typeLowerCase.includes("video");
	const setInteractive = typeLowerCase.includes("interactive");
	const setAssessment = typeLowerCase.includes("suite");

	return (
		<span className="mediaType">
			{setVideo && <FontAwesomeIcon icon={faVideo} data-test-class="media-type-video-icon" />}
			{setInteractive && <FontAwesomeIcon icon={faComputerMouse} data-test-class="media-type-interactive-icon" />}
			{setAssessment && <FontAwesomeIcon icon={faClipboardList} data-test-class="media-type-assessment-icon" />}
		</span>
	);
};

export default MediaType;
